/**
 * Estrelas dos craques: quem tem overall alto ganha de 1 a 5 estrelas ao lado do nome.
 *
 * ATENÇÃO à escala: no WebFoot o overall dos melhores do mundo vai até uns 75 (Mbappé e Haaland), então "80 ou mais" não pegaria
 * ninguém. Os cortes abaixo foram postos para que só cerca de 1,5% dos jogadores tenham estrela (uns 125 de ~8.900 com o mundo
 * inteiro) e as 5 estrelas sejam raríssimas. Para mexer no critério, basta mudar CORTES_ESTRELAS.
 */

/** Overall mínimo para 1, 2, 3, 4 e 5 estrelas. */
export const CORTES_ESTRELAS: readonly [number, number, number, number, number] = [65, 68, 71, 73, 75];

/** Estrelas (0 a 5) de um overall. */
export function estrelasDoOverall(overall: number): number {
  let n = 0;
  for (const corte of CORTES_ESTRELAS) if (overall >= corte) n++;
  return n;
}

/** Estrelas (0 a 5) do jogador. */
export const estrelasDe = (j: { overall: number }): number => estrelasDoOverall(j.overall);
